import { useSelector } from 'react-redux'

import { Localisation, ProductConfig, Support } from '@/types'
import { ReduxState } from '@/config/redux/types'

const selectLocalisation = (state: ReduxState): Localisation =>
  state.productConfig.localisation

const selectSupportInfo = (state: ReduxState): Support =>
  state.productConfig.common.support

const selectWebAppUrl = (state: ReduxState): string =>
  state.productConfig.app.webAppUrl

const selectCookiePolicyLink = (state: ReduxState): string =>
  state.productConfig.cookiePolicyLink

const selectRegulatoryPolicyLink = (state: ReduxState): string | undefined =>
  state.productConfig.regulatoryPolicyLink

const selectWebSignupConfig = (state: ReduxState): ProductConfig['webSignup'] =>
  state.productConfig.webSignup

const selectAppName = (state: ReduxState): string =>
  state.productConfig.common.appname

const selectLocusUrl = (state: ReduxState): string =>
  state.productConfig.app.locusCdnUrl

const selectCTAs = (state: ReduxState): string[] =>
  state.productConfig.webSignup.enabledCtas

const selectBookUrl = (state: ReduxState): string =>
  state.productConfig.webSignup.bookUrl

const selectOidcRegistration = (state: ReduxState): boolean =>
  state.productConfig.webSignup.oidcRegistration

const useLocalisation = () => useSelector(selectLocalisation)
const useSupportInfo = () => useSelector(selectSupportInfo)
const useWebAppUrl = () => useSelector(selectWebAppUrl)
const useCookiePolicyLink = () => useSelector(selectCookiePolicyLink)
const useRegulatoryPolicyLink = () => useSelector(selectRegulatoryPolicyLink)
const useAbTestName = () => useSelector(selectWebSignupConfig).abTestName
const useAbTestVariant = () =>
  useSelector(selectWebSignupConfig).configIndex + 1 // Product config uses 1 based array indexes. Sigh...
const useLocusUrl = () => useSelector(selectLocusUrl)
const useCTAs = () => useSelector(selectCTAs)
const useBookUrl = () => useSelector(selectBookUrl)
const useOidcRegistration = () => useSelector(selectOidcRegistration)

export {
  useLocalisation,
  selectLocalisation,
  useSupportInfo,
  selectSupportInfo,
  useWebAppUrl,
  selectWebAppUrl,
  useCookiePolicyLink,
  selectCookiePolicyLink,
  useRegulatoryPolicyLink,
  selectRegulatoryPolicyLink,
  useAbTestName,
  useAbTestVariant,
  selectAppName,
  useLocusUrl,
  selectLocusUrl,
  useCTAs,
  useBookUrl,
  useOidcRegistration,
}
